import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import InputBox from './InputBox';
import PhoneBox from '../../components/register/PhoneBox';
import { Button, Container, Form, ModalTitle, Row } from './CompletarDatosElements';
import { errorNotification, successNotification } from '../../utils/toastNotifications';
import { API_URL } from '../../const/api';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { selectId, selectToken, selectUser, setNewToken } from '../../features/user/userSlice';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';


const initialForm = {
  nombre: '',
  cedula: '',
  telefono: '',
  nueva_password:'',
  verificar_password:''
}

const CompletarDatos = ({setHideNav}) => {
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);
  const [cookies, setCookie] = useCookies(['user']);

  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [codigoArea, setCodigoArea] = useState('+1');
  const [t] = useTranslation('global');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(()=>{
    setHideNav(true);
    return () => {setHideNav(false)};
  },[]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    for(let x in form) {
      if(form[x]==='') return errorNotification(t('alert.errorNotificationDeposito-6'));
    }
    for(let x in errors) {
      if(errors[x]==='') return errorNotification(t('alert.errorNotificationRetiro-68'));
    }

    setLoading(true);
    const body = {...form, telefono: codigoArea+" "+form.telefono, id_uo, token}
    const res = await axios.post(API_URL+'completarDatos', body);
    dispatch(setNewToken(res.data.token));
    if(res.data.status===1) {
      if(res.data.response.includes('correctamente')) {
        let tomorrow = new Date();
        tomorrow.setDate(new Date().getDate()+1);
        const enc = await axios.post(API_URL+'guardar', {a: user, b: form.nueva_password});
        if(enc.data) {
          setCookie('MBA', enc.data.aenc, { path: '/', expires: tomorrow });
          setCookie('MBB', enc.data.benc, { path: '/', expires: tomorrow });
        }
        successNotification(res.data.response);
        setTimeout(()=>{
          navigate('/');
        },1000)
      } else {
        setLoading(false);
        errorNotification(res.data.response);
      }
    }

  }

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  }

  const handleCountry = (val) => {
    setCodigoArea(val);
  } 

  return (
    <Container>
        <ModalTitle>{t('user-menu.lbl-cuenta')}</ModalTitle>
        <Form onSubmit={handleSubmit} autoComplete='off'>
          <Row>
            <InputBox 
              label={t('sign-in.lbl-fullname')}
              placeholder={t('sign-in.lbl-fullname')} 
              val={form.nombre} 
              handleChange={handleChange}
              name='nombre'
              errors={errors}
              type='text'
            />
            <InputBox 
              label={t('sign-in.input-id')}
              placeholder={t('sign-in.input-id')} 
              val={form.cedula} 
              handleChange={handleChange}
              name='cedula'
              setErrors={setErrors}
              errors={errors}
              type='text'
            />
          </Row>
          <Row>
            <PhoneBox value={form.telefono} handleCountry={handleCountry} handleChange={handleChange} error={errors.telefono} />
          </Row>
          <Row>
            <InputBox 
              label={t('password.lbl-2')}
              placeholder={t('password.lbl-2')} 
              val={form.nueva_password} 
              handleChange={handleChange}
              name='nueva_password'
              errors={errors}
              type='password'
              setErrors={setErrors}
            />
            <InputBox 
              label={t('password.lbl-3')}
              placeholder={t('password.lbl-3')}
              val={form.verificar_password} 
              handleChange={handleChange}
              name='verificar_password'
              form={form.nueva_password}
              errors={errors}
              type='password'
              setErrors={setErrors}
            />

          </Row>

          <Button disabled={loading} type='submit'>{loading ? t('deposit.loading') : t('userProfile.guardar')}</Button>
        </Form>
    </Container>

  )
}

export default CompletarDatos;